import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { remove } from '../Store/Slice'
import Msg from '../components/Msg'
const Cart = () => {
  const dispatch = useDispatch()
  const product = useSelector(state=>state.cart)
  const handleRemove=(productid)=>{
 dispatch(remove(productid))
  }

  return (
    <div>
      <h1>cart</h1>
      {
  product.length=='' ? <Msg/>:  product.map(product=>{
        return(
            <div className="Cmain">
            <div className="card" >
                  <div className="card-body" key={product.id}>
            <img src={product.image} alt={product.name} className="card-img-top"/>
            <h5 className="card-title">{product.title}</h5>
          
            <p className="card-price">RS ${product.price}</p>
            <button  className="card-button" onClick={()=>handleRemove(product.id)}>Remove</button>
            </div>
        </div>
        </div>
        )
    })
}
    </div>

  )
}

export default Cart